<!--
 * @Author:
 * @LastEditTime: 2022-04-26 18:11:05
 * @Description: zhouhuan
-->
<template>
  <div
    v-drag
    class="position-absolute model-tree"
    :class="setSemitransparent ? 'semitransparent' : ''"
  >
    <div slot="header">
      <span class="fz-14">模型树</span>
    </div>
    <div class="model_content">
      <div class="height-38 m-t-5">
        <el-input
          size="small"
          placeholder="请输入要过滤的设备"
          v-model="filterTreeKeyWords"
          @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-arrow-down"
            class="p-l-10 p-r-10"
            @click="filterModelTree(currentNodeItem, true, filterTreeKeyWords, 0)"
          ></el-button>
          <el-button
            slot="append"
            icon="el-icon-arrow-up"
            class="p-l-10 p-r-10"
            @click="filterModelTree(currentNodeItem, false, filterTreeKeyWords, 0)"
          ></el-button>
        </el-input>
      </div>
      <el-tree
        v-if="modelTreeVisbile"
        class="m-t-5"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="item"
      ></el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modelTreeDialog',
  props: {
    treeData: {
      type: Array,
      default: [],
    },
    currentNodeItemF: {
      type: Number,
      default: 0,
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [],
        }
      },
    },
    setSemitransparent: {
      type: Boolean,
      default: false,
    },
    currentNodeNameF: {
      type: String,
      default: '',
    },
    player: {
      type: Object,
      default: null,
    },
    filterItem: {
      type: Array,
      default: () => {
        return []
      },
    },
    modelHideList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    currentNodeItemF(val) {
      if (val) {
        this.currentNodeItem = val
      }
    },
    currentNodeNameF(val) {
      if (val) {
        this.currentNodeName = val
        this.filterModelTree(0, true, val, 3)
      }
    },
    'modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
  },
  created() {
    if (this.currentNodeNameF) {
      this.currentNodeName = this.currentNodeNameF
      this.filterModelTree(0, true, this.currentNodeNameF, 0)
    }
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      currentNodeItem: 0, // 当前激活的node
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
    }
  },
  methods: {
    // 模型树点击操作
    clickModelTree(data, node) {
      this.$emit('clickModelTree', data, node)
      this.locationNode(data.item)
    },
    // 模型树加载
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.treeData, (el) => {
        return this.filterItem.indexOf(el.item) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.item
        })
        return resolve(this.treeData)
      }
      const res = await PlayerUtils.call(this.player.Native.ModelTree.getSubItems, node.data.item)
      const filterRes = _.filter(res, (el) => {
        return el.name && el.visible
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.filterItem.indexOf(el.item) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.item
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.checked
        }),
        (res5) => {
          return res5.item
        }
      )
      // 查看当前节点是否没有在影藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = function(nodeObj) {
        return (
          _.indexOf(
            _.map(_this.modelHideList, (res1) => {
              return res1.item
            }),
            nodeObj.data.item
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在影藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在影藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在影藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在影藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          if (_.some(filterRes, { checked: false })) {
            this.modelTreeProp.defaultCheckedKey = [
              ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
                return val !== node.data.item
              }),
              ...checkedKeys,
            ]
          }
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.item) {
          if (el.item === this.currentNode.item) {
            this.locationNode(this.currentNode.item)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('el-tree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          console.log(currentNode.offsetTop, 111)
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 600)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      console.log(data, checkeds)
      const isChecked = _.includes(checkeds.checkedKeys, data.item)
      this.$emit('setModelVisible', 'checkModelTree', isChecked, data, checkeds)
    },
    async filterModelTree(startItem, direction, KeyWords, type) {
      // 过滤模型树
      this.currentNode = await PlayerUtils.call(
        this.player.Native.ModelTree.findItemByName,
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendNode(node) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      console.log(node, 'expendNode______')
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: node.checked })
            this.currentNodeItem = this.currentNode.item // 储存选中节点的item
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          node.parentItem
        )
        await this.expendNode(res)
        // 展开
        this.defaultExpandedKeys.push(res.item)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
  },
}
</script>

<style lang="scss" scoped>

@import '../css/semitransparent.scss';
.model-tree {
  top: 44px;
  width: 450px;
  height: 500px;
  left: 0;
  z-index: 100;
  background-color: rgba(250, 250, 250, 0.8) !important;
  border-radius: 2px;
  /deep/.el-tree {
    height: calc(100% - 40px);
    overflow-y: auto;
  }
  padding: 10px;
  border: none !important;
}
.model_content {
  padding: 0 !important;
  height: calc(100% - 25px);
  border-radius: 2px;
}

</style>
